import React from 'react';
import { Box, IconButton, Menu, MenuItem, Tooltip, Typography, Avatar } from '@mui/material';
import { useState } from 'react'; 
import { useAuth0, LogoutOptions } from '@auth0/auth0-react';
import ProfileIcon from './ProfileIcon';
import { useNavigate } from 'react-router-dom';

const ProfileDropdown: React.FC = () => {
    const {user, logout} = useAuth0();
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const settings = ['Profile', 'Logout'];
    const navigate = useNavigate();

 
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleSelection = (setting: string) => () => {
        console.log(`Selected: ${setting}`);
        if (setting === 'Logout') {
            // Implement logout logic here
            console.log('Logging out...');
            logout({ returnTo: window.location.origin } as LogoutOptions);
        }
        else if(setting === 'Profile'){
            navigate('/profile');
        }
        handleCloseUserMenu();
    }



    return (
        <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <ProfileIcon
                onClick={handleOpenUserMenu}
              />
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleSelection(setting)}>
                  <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
    );
}

export default ProfileDropdown;